var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.182,
    height: 41.217,
    viewBox: "0 0 39.182 41.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1598",
    x: 0,
    y: 0,
    width: 39.182,
    height: 41.217,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9667",
    "data-name": "Group 9667",
    transform: "translate(4.5 3.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9663",
    "data-name": "Group 9663",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -3.5)",
    filter: "url(#Rectangle_1598)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1598-2",
    "data-name": "Rectangle 1598",
    width: 30.182,
    height: 32.217,
    rx: 4,
    transform: "translate(4.5 3.5)",
    fill: "#040227"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9664",
    "data-name": "Group 9664",
    transform: "translate(4.778 6.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7436",
    "data-name": "Path 7436",
    d: "M23.271,12.334H20.544L13.526,7.071a.356.356,0,0,0-.427,0L6.082,12.334H3.356A.356.356,0,0,0,3,12.69V24.426a.356.356,0,0,0,.356.356H23.271a.356.356,0,0,0,.356-.356V12.69A.356.356,0,0,0,23.271,12.334ZM13.313,7.8l6.046,4.534H7.267Zm9.6,16.27H3.711V13.046h19.2Z",
    transform: "translate(-3 -7)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7437",
    "data-name": "Path 7437",
    d: "M7,26.305v7.634a.305.305,0,0,0,.305.305H21.962a.305.305,0,0,0,.305-.305V26.305A.305.305,0,0,0,21.962,26H7.305A.305.305,0,0,0,7,26.305Zm.611.305H21.656v7.023H7.611Z",
    transform: "translate(-4.321 -18.603)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundIcon);
export default __webpack_public_path__ + "static/media/background-icon.ba908207a58ceeb8fda3fb55d76f1a79.svg";
export { ForwardRef as ReactComponent };